import { color, Text } from '@starrez/starryui9';
import * as React from 'react';
import styled from 'styled-components';
import { HStack } from '@starrez/starryui9';
import { INodeProps } from './types';
import { Group } from './Group';
import { useState } from 'react';
import { useTreeContext } from './Context';

export const Node = (props: INodeProps) => {
    const [visible, setVisible] = useState<boolean>(Boolean(props.isExpanded));

    const { node: ExternalNode, onSelect } = useTreeContext();

    return (
        <>
            <HStack columns={props.isFolder ? '30px min-content' : 'min-content'}>
                {props.isFolder && (
                    <IconButton type="button" disabled={!props.hasChildren} visible={visible} onClick={() => setVisible(!visible)}>
                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M9.71429 0.607143C9.71429 0.771578 9.6542 0.913876 9.53404 1.03404L5.28404 5.28404C5.16388 5.4042 5.02158 5.46429 4.85714 5.46429C4.69271 5.46429 4.55041 5.4042 4.43025 5.28404L0.180246 1.03404C0.0600812 0.913876 0 0.771578 0 0.607143C0 0.442708 0.0600812 0.30041 0.180246 0.180246C0.30041 0.0600812 0.442708 0 0.607143 0H9.10714C9.27158 0 9.41388 0.0600812 9.53404 0.180246C9.6542 0.30041 9.71429 0.442708 9.71429 0.607143Z"
                                fill="currentColor"
                            />
                        </svg>
                    </IconButton>
                )}
                <Button type="button" selected={Boolean(props.isSelected)} onClick={() => onSelect(props)}>
                    {ExternalNode ? <ExternalNode visible={visible} {...props} /> : <Text>{props.caption}</Text>}
                </Button>
            </HStack>

            {visible && <Group parentId={props.id} />}
        </>
    );
};

const IconButton = styled.button<{ visible: boolean }>`
    background: transparent;
    text-align: left;
    border: none;
    width: 30px;
    display: grid;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    height: 30px;
    transform: ${(props) => (props.visible ? 'rotate(0deg)' : 'rotate(-90deg)')};
    cursor: pointer !important;
    color: #566878;

    &:hover {
        background: #ebf6ff;
        color: ${color.Blue.B60};
        border-radius: 4px;
    }

    &[disabled] {
        opacity: 0.4;
    }

    &[disabled]:hover {
        cursor: not-allowed !important;
        background: white;

        * {
            cursor: not-allowed !important;
        }
    }
`;

const Button = styled.button<{ selected: boolean }>`
    background: transparent;
    text-align: left;
    border: none;
    padding: 0 8px;
    margin: 0;
    height: 30px;
    white-space: nowrap;
    cursor: pointer !important;
    color: ${color.Grey.G80};
    border-radius: 4px;

    ${(props) =>
        props.selected
            ? `
                background: ${color.Blue.B60};
                color: white;
                `
            : `
        &:hover {
            background: #ebf6ff;
            color: ${color.Blue.B60};
        }
    `}

    * {
        cursor: pointer !important;
    }
`;
